import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NavigationBar.css'


export default function NavigationBar({ clicked }) {
  const navigate = useNavigate();
  const [showmobnav, setshowmobnav] = useState(false);
  const [showcart, setshowcart] = useState(false);
  const [itemsCount, setItemsCount] = useState(0);
  const isLoggedIn = !!localStorage.getItem("authToken");

  useEffect(() => {
    const updateItemsCount = () => {
      setItemsCount(localStorage.getItem("Added") ? JSON.parse(localStorage.getItem("Added")).length : 0);
    };

    updateItemsCount();
    const intervalId = setInterval(updateItemsCount, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 783) {
        setshowcart(true);
      } else {
        setshowcart(false);
      }
    };

    // run once initially
    handleResize();

    // listen for resize
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const showmobna = () => {
    setshowmobnav(!showmobnav);
  }

  return (
    <>
      <nav>
        <div className="mobilehamburger" onClick={showmobna}><i class="fa-solid fa-bars"></i></div>
        <h1>INIFITS</h1>
        <ul>
          <Link to='/' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>Home</li>
          </Link>
          <Link to='/Collections' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>Collections</li>
          </Link>
          <Link to='/Products' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>Products</li>
          </Link>
          <Link to='/About-Us' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>About Us</li>
          </Link>
          <Link to='/Contact-Us' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>Contact Us</li>
          </Link>
          
          <Link to='/track' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>Track Order</li>
          </Link>
        </ul>
        <div className="optional">
          {!showcart && (
            <span className="cart-icon">
              <i className="fa-solid fa-cart-shopping" onClick={() => navigate("/cart")}></i>
                <p>{itemsCount}</p>
            </span>
          )}
        </div>
        {isLoggedIn ? (
          <div className="buttonsnav">
            {showcart && (
              <span className="cart-icon">
                <i className="fa-solid fa-cart-shopping" onClick={() => navigate("/cart")}></i>
                <p>{itemsCount}</p>
              </span>
            )}
            <button className="loginbtn pc" style={{color:'black'}} onClick={() => {
              localStorage.removeItem("authToken"); // Optional: logout
              localStorage.removeItem("userEmail");
              localStorage.removeItem("userName");
              localStorage.removeItem("userPhone");
              localStorage.removeItem("userRole");
              localStorage.removeItem("userUsedCodes")
              navigate("/");
            }}>
              Logout
            </button>
          </div>
        ) : (
          <div className="buttonsnav">
            {showcart && (
              <span className="cart-icon">
                <i className="fa-solid fa-cart-shopping" onClick={()=>navigate("/cart")}></i>
                <p>{itemsCount}</p>
              </span>
            )}
            <button className="loginbtn pc" style={{color:'black'}}  onClick={() => navigate("/Log-In")}>Login</button>
            <button className="signupbtn pc" style={{color:'black'}} onClick={() => navigate("/Sign-Up")}>Sign Up</button>
          </div>
        )}


      </nav>
      <div className="divmob" style={{ transition: '0.5s', left: showmobnav ? '0' : '-100%', display: 'flex' }}>
        <div className="mobilehamburger" onClick={showmobna}> <i class="fa-solid fa-xmark"></i></div>
        <ul>
          <Link to='/' onClick={showmobna} style={{ textDecoration: 'none', color: 'white' }}>
            <li className='limob'>Home</li>
          </Link>
          <Link to='/Collections' onClick={showmobna} style={{ textDecoration: 'none', color: 'white' }}>
            <li className='limob'>Collections</li>
          </Link>
          <Link to='/Products' onClick={showmobna} style={{ textDecoration: 'none', color: 'white' }}>
            <li className='limob'>Products</li>
          </Link>
          <Link to='/About-Us' onClick={showmobna} style={{ textDecoration: 'none', color: 'white' }}>
            <li className='limob'>About Us</li>
          </Link>
          <Link to='/Contact-Us' onClick={showmobna} style={{ textDecoration: 'none', color: 'white' }}>
            <li className='limob'>Contact Us</li>
          </Link>
          
          <Link to='/track' className='lipc' style={{ textDecoration: 'none', color: 'white' }}>
            <li>Track Order</li>
          </Link>
        </ul>




        {isLoggedIn ? (
          <div className="buttonsnav">
            <button className="loginbtn" style={{color:'black'}}  onClick={() => {
              localStorage.removeItem("authToken"); // Optional: logout
              localStorage.removeItem("userEmail");
              localStorage.removeItem("userName");
              localStorage.removeItem("userPhone");
              navigate("/");
              showmobna();
            }}>
              Logout
            </button>
          </div>
        ) : (
          <div className="buttonsnav">
            <button className="loginbtn" style={{color:'black'}}  onClick={() => { navigate("/Log-In"); showmobna(); }}>
              Login
            </button>
            <button className="signupbtn" style={{color:'black'}}  onClick={() => { navigate("/Sign-Up"); showmobna(); }}>
              Sign Up
            </button>
          </div>
        )}







      </div>

    </>
  )
}